import { useEffect } from "react";

/**
 * Swaps the browser tab title + favicon to the Management USA NJ brand
 * while the user is on any Management-USA-NJ portal (admin at
 * /managementusa/*, worker at /worker/*, and all branded auth pages
 * for both portals). Restores the previous favicon + title on unmount
 * so navigating back to a Catskills page doesn't inherit the mgmt icon.
 *
 * Favicon is an inline SVG data URI — same technique as the colony
 * hook — so no new binary asset is required. Uses the exact same
 * emerald-on-slate palette as the mgmt/worker portal headers.
 */
const MGMT_FAVICON =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <rect width="64" height="64" rx="10" fill="#0F172A"/>
      <path fill="#34D399" d="M14 46V22h8v10h6V22h8v24h-8V34h-6v12z"/>
      <path fill="#34D399" d="M40 46V22h10c4 0 6 2 6 6v4c0 2-1 3-3 4l4 10h-8l-3-8h-0v8zm8-14h2c1 0 2-1 2-2v-1c0-1-1-2-2-2h-2z"/>
    </svg>`
  );

export function useMgmtBrand(title = "Management USA NJ") {
  useEffect(() => {
    const prevTitle = document.title;
    const iconLinks = Array.from(
      // NOTE: rel='icon' ONLY. Never touch apple-touch-icon here — iOS can't
      // use SVG data-URIs for Home Screen icons and would silently fall back
      // to the root /apple-touch-icon.png (the DRIVER icon). The per-portal
      // InstallAppButton sets the correct PNG apple-touch-icon instead.
      document.querySelectorAll("link[rel='icon']")
    );
    const prevIcons = iconLinks.map((el) => ({
      el,
      href: el.getAttribute("href"),
      type: el.getAttribute("type"),
    }));

    document.title = title;
    iconLinks.forEach((el) => {
      el.setAttribute("href", MGMT_FAVICON);
      el.setAttribute("type", "image/svg+xml");
    });

    return () => {
      document.title = prevTitle;
      prevIcons.forEach(({ el, href, type }) => {
        if (href) el.setAttribute("href", href); else el.removeAttribute("href");
        if (type) el.setAttribute("type", type); else el.removeAttribute("type");
      });
    };
  }, [title]);
}
